import React, { useMemo, useState, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { useDispatch, useSelector } from "react-redux";
import { getAuditList } from "../../Utils/actions/yh";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import {
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  TextField,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { styled } from "@mui/system";
import CachedIcon from "@mui/icons-material/Cached";
import "./Audit.scss";
import FilterListIcon from "@mui/icons-material/FilterList";

const Audit = () => {
  const dispatch = useDispatch();
  const { auditValue } = useSelector((state) => state.yh);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(
    sessionStorage.getItem("auditPageSize")
      ? sessionStorage.getItem("auditPageSize")
      : 10
  );
  const [paginatedData, setPaginatedData] = useState([]);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [startGMTdate, setStartGMTdate] = useState(null);
  const [endGMTdate, setEndGMTdate] = useState(null);

  useEffect(() => {
    dispatch(
      getAuditList(
        pageSize,
        pageIndex,
        startGMTdate ? startGMTdate : null,
        endGMTdate ? endGMTdate : null
      )
    );
  }, [pageSize, pageIndex, startGMTdate, endGMTdate]);

  useEffect(() => {
    if (auditValue && auditValue.data) {
      const totalRecords = auditValue.totalRecord || 0;

      const startIndex = pageIndex * pageSize;

      const endIndex = Math.min(startIndex + pageSize, totalRecords);

      const newData = auditValue.data.map((time) => {
        const startPointDate = new Date(time.timestamp);
        const startPointFormatted = startPointDate
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        return {
          ...time,
          timestamp: startPointFormatted,
        };
      });

      setPaginatedData(newData);
    }
  }, [auditValue, pageIndex, pageSize]);

  sessionStorage.setItem("auditPageSize", pageSize);

  const columns = useMemo(
    () => [
      // {
      //   accessorKey: "id",
      //   header: "Id",
      // },
      {
        accessorKey: "timestamp",
        header: "Time",
      },
      {
        accessorKey: "action",
        header: "Action",
      },
      {
        accessorKey: "username",
        header: "User Name",
      },
      {
        accessorKey: "description",
        header: "Description",
      },
      {
        accessorKey: "entityName",
        header: "Entity Name",
      },
    ],
    []
  );

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndex(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(auditValue.totalRecord / pageSize);
    setPageIndex(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  const handleStartDateChange = (date) => {
    setStartTime(date);
    setPageIndex(0);
  };

  const handleEndDateChange = (date) => {
    setEndTime(date);
    setPageIndex(0);
  };

  useEffect(() => {
    if (startTime) {
      const startDate = new Date(startTime);
      setStartGMTdate(
        startDate.getTime() - startDate.getTimezoneOffset() * 60000
      );
    }
  }, [startTime]);

  useEffect(() => {
    if (endTime) {
      const endDate = new Date(endTime);
      setEndGMTdate(endDate.getTime() - endDate.getTimezoneOffset() * 60000);
    }
  }, [endTime]);

  const CustomDateTimePicker = styled(DateTimePicker)({
    "& .MuiInputBase-root": {
      overflow: "hidden",
      height: "35px",
      position: "relative",
      marginBottom: "10px",
    },
    "& .MuiPickersToolbar-root": {
      minHeight: "24px",
    },
    '& .MuiInputLabel-root[data-shrink="true"]': {
      top: "0px",
    },
    '& .MuiInputLabel-root[data-shrink="false"]': {
      top: "-8px",
    },
  });

  return (
    <>
      <div
        style={{
          display: "block",
          width: "100%",
          overflow: "auto",
          padding: "0px 0px",
        }}
      >
        <MaterialReactTable
          muiTableHeadCellProps={{
            sx: {
              backgroundColor: "#2e2e2e", // dark head
              color: "#ccc",
            },
          }}
          muiTableHeadProps={{
            sx: {
              overflow: "auto",
              backgroundColor: "#2e2e2e",
              "&::-webkit-scrollbar": {
                width: "12px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#444", // darker thumb
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#2e2e2e",
              },
            },
          }}
          muiTableHeadCellContentProps={{
            sx: {
              color: "#ccc !important", // text color
              "& svg": {
                color: "#ccc !important", // sort icon color
              },
            },
          }}
          muiTableBodyProps={{
            sx: {
              overflow: "auto",
              scrollbarWidth: "thin",
              backgroundColor: "#181818", // dark body
              "&::-webkit-scrollbar": {
                width: "10px",
                backgroundColor: "#181818",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#444",
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#23272f",
              },
              // "& tr:nth-of-type(odd)": {
              //   backgroundColor: "#23272f",
              // },
              // "& tr:nth-of-type(even)": {
              //   backgroundColor: "#181818",
              // },
              "& td": {
                padding: "0.5rem",
                borderBottom: "1px solid #333",
                color: "#c7c7c7",
              },
            },
          }}
          // muiTabEditIconleHeadCellProps={{
          //   sx: {
          //     backgroundColor: "#286685",
          //     color: "#fff",
          //     boxShadow: "none !important",
          //   },
          // }}
          // muiTableProps={{
          //   sx: {
          //     border: "none",
          //     boxShadow: "none !important",
          //   },
          // }}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              input: {
                color: "#fff", // Input text color
                backgroundColor: "#272727", // Dark background
                "&::placeholder": {
                  color: "#fff", // Placeholder text color
                  opacity: 0.7,
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#888", // Border color
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#aaa",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#fff",
              },
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              color: "#fff", // All body cell text white
            },
          }}
          muiTablePaperProps={{
            sx: {
              boxShadow: "none",
              height: "auto",
              width: "100%",
              position: "static",
              display: "block",
              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "#23272f", // dark table background
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                width: "12px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#444",
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#23272f",
              },
            },
          }}
          muiTableContainerProps={{
            sx: {
              maxHeight: "59vh",
              boxShadow: "none !important",
              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "#181818",
            },
          }}
          muiTableBodyRowProps={({ row, index }) => ({
            sx: {
              cursor: "pointer",
              boxShadow: "none !important",

              backgroundColor: row.getIsSelected()
                ? "#1c1c1c"
                : // : index % 2 === 0
                  // ? "#cfd5e959"
                  "#121212",
            },
          })}
          columns={columns}
          data={paginatedData}
          enableRowActions={false}
          enableEditing={false}
          enableStickyHeader={true}
          enableStickyFooter={false}
          enableDensityToggle={false}
          enableFullScreenToggle={false}
          positionActionsColumn="last"
          editDisplayMode="row"
          enableFilters={true}
          enableHiding={false}
          enablePagination={false}
          renderTopToolbar={({ table }) => (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  background: "#181818",
                  padding: "0.5rem 1rem",
                  gap: "1rem",
                }}
              >
                {/* Left side: DatePickers + Reset Icon */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "1rem",
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={["DateTimePicker", "DateTimePicker"]}
                    >
                      <CustomDateTimePicker
                        label="Start Time"
                        value={startTime}
                        onChange={handleStartDateChange}
                        format="YYYY-MM-DD HH:mm:ss"
                        views={["year", "day", "hours", "minutes", "seconds"]}
                        ampm={false}
                      />
                    </DemoContainer>
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={["DateTimePicker", "DateTimePicker"]}
                    >
                      <CustomDateTimePicker
                        label="End Time"
                        value={endTime}
                        onChange={handleEndDateChange}
                        format="YYYY-MM-DD HH:mm:ss"
                        views={["year", "day", "hours", "minutes", "seconds"]}
                        ampm={false}
                      />
                    </DemoContainer>
                  </LocalizationProvider>

                  <CachedIcon
                    onClick={() => {
                      setStartTime(null);
                      setEndTime(null);
                      setStartGMTdate(0);
                      setEndGMTdate(0);
                      setPageIndex(0);
                    }}
                    style={{
                      cursor: "pointer",
                      color: "grey",
                      marginTop: "5px",
                    }}
                  />
                </div>

                {/* Right side: Search and Filter */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "1rem",
                  }}
                >
                  <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Search..."
                    value={table.getState().globalFilter || ""}
                    onChange={(e) => table.setGlobalFilter(e.target.value)}
                    sx={{
                      minWidth: "250px",
                      input: { color: "#c7c7c7", background: "#272727" },
                      "& legend": { display: "none" },
                    }}
                  />
                  <Tooltip title="Show Filters">
                    <IconButton
                      onClick={() =>
                        table.setShowColumnFilters(
                          !table.getState().showColumnFilters
                        )
                      }
                    >
                      <FilterListIcon sx={{ color: "#c7c7c7 !important" }} />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            </>
          )}
          renderBottomToolbarCustomActions={({ table }) => (
            <>
              <div style={{ marginLeft: "auto", color: "#c7c7c7" }}>
                <span>Rows per Page </span>&nbsp;
                <FormControl variant="standard" size="small">
                  <Select
                    value={pageSize}
                    onChange={(e) =>
                      handlePageSizeChange(Number(e.target.value))
                    }
                    sx={{
                      color: "#c7c7c7",
                      ".MuiSelect-icon": { color: "#c7c7c7" },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: "#444",
                      },
                    }}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                &nbsp;
                <span>
                  {pageIndex * pageSize + 1}-
                  {Math.min(
                    pageIndex * pageSize + pageSize,
                    auditValue.totalRecord
                  )}{" "}
                  of &nbsp;
                  {auditValue.totalRecord}&nbsp;
                </span>
                <FirstPageIcon
                  onClick={() => {
                    if (pageIndex !== 0) {
                      handleStartChange();
                    }
                  }}
                  style={{
                    cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                    color:
                      pageIndex === 0 ? "rgba(255,255,255,0.26)" : "#c7c7c7",
                  }}
                />
                <NavigateBeforeIcon
                  onClick={() => {
                    if (pageIndex !== 0) {
                      handlePageChange(pageIndex - 1);
                    }
                  }}
                  style={{
                    cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                    color:
                      pageIndex === 0 ? "rgba(255,255,255,0.26)" : "#c7c7c7",
                  }}
                />
                <NavigateNextIcon
                  onClick={() => {
                    if ((pageIndex + 1) * pageSize < auditValue.totalRecord) {
                      handlePageChange(pageIndex + 1);
                    }
                  }}
                  style={{
                    cursor:
                      (pageIndex + 1) * pageSize >= auditValue.totalRecord
                        ? "not-allowed"
                        : "pointer",
                    color:
                      (pageIndex + 1) * pageSize >= auditValue.totalRecord
                        ? "rgba(255,255,255,0.26)"
                        : "#c7c7c7",
                  }}
                />
                <LastPageIcon
                  onClick={() => {
                    if ((pageIndex + 1) * pageSize < auditValue.totalRecord) {
                      handleEndChange();
                    }
                  }}
                  style={{
                    cursor:
                      (pageIndex + 1) * pageSize >= auditValue.totalRecord
                        ? "not-allowed"
                        : "pointer",
                    color:
                      (pageIndex + 1) * pageSize >= auditValue.totalRecord
                        ? "rgba(255,255,255,0.26)"
                        : "#c7c7c7",
                  }}
                />
              </div>
            </>
          )}
        />
      </div>
    </>
  );
};

export default Audit;
